import { allLocales } from "../generated/locale-codes.js";

export const matchedLocaleMap: Record<string, typeof allLocales[number]> = {
  // 阿拉伯语: 
  'ar': 'ar',
  'ar-AE': 'ar',
  'ar-BH': 'ar',
  'ar-DZ': 'ar',
  'ar-EG': 'ar',
  'ar-IQ': 'ar',
  'ar-JO': 'ar',
  'ar-KW': 'ar',
  'ar-LB': 'ar',
  'ar-LY': 'ar',
  'ar-MA': 'ar',
  'ar-OM': 'ar',
  'ar-QA': 'ar',
  'ar-SA': 'ar',
  'ar-SY': 'ar',
  'ar-TN': 'ar',
  'ar-YE': 'ar',
  // 保加利亚语: 
  'bg': 'bg',
  'bg-BG': 'bg',
  // 捷克语: 
  'cs': 'cs',
  'cs-CZ': 'cs',
  // 丹麦语: 
  'da': 'da',
  'da-DK': 'da',
  // 德语: 
  'de': 'de',
  'de-AT': 'de',
  'de-CH': 'de',
  'de-DE': 'de',
  'de-LI': 'de',
  'de-LU': 'de',
  // 希腊语: 
  'el': 'el',
  'el-GR': 'el',
  // 英语: 
  'en': 'en',
  'en-AU': 'en',
  'en-BZ': 'en',
  'en-CA': 'en',
  'en-CB': 'en',
  'en-GB': 'en',
  'en-IE': 'en',
  'en-JM': 'en',
  'en-NZ': 'en',
  'en-PH': 'en',
  'en-TT': 'en',
  'en-US': 'en',
  'en-ZA': 'en',
  'en-ZW': 'en',
  // 西班牙语: 
  'es': 'es',
  'es-AR': 'es',
  'es-BO': 'es',
  'es-CL': 'es',
  'es-CO': 'es',
  'es-CR': 'es',
  'es-DO': 'es',
  'es-EC': 'es',
  'es-ES': 'es',
  'es-GT': 'es',
  'es-HN': 'es',
  'es-MX': 'es',
  'es-NI': 'es',
  'es-PA': 'es',
  'es-PE': 'es',
  'es-PR': 'es',
  'es-PY': 'es',
  'es-SV': 'es',
  'es-UY': 'es',
  'es-VE': 'es',
  // 爱沙尼亚语: 
  'et': 'et',
  'et-EE': 'et',
  // 芬兰语: 
  'fi': 'fi',
  'fi-FI': 'fi',
  // 法语: 
  'fr': 'fr',
  'fr-BE': 'fr',
  'fr-CA': 'fr',
  'fr-CH': 'fr',
  'fr-FR': 'fr',
  'fr-LU': 'fr',
  'fr-MC': 'fr',
  // 克罗地亚语: 
  'hr': 'hr',
  'hr-BA': 'hr',
  'hr-HR': 'hr',
  // 匈牙利语: 
  'hu': 'hu',
  'hu-HU': 'hu',
  // 印尼语: 
  'id': 'id',
  'id-ID': 'id',
  // 意大利语: 
  'it': 'it',
  'it-CH': 'it',
  'it-IT': 'it',
  // 日语: 
  'ja': 'ja',
  'ja-JP': 'ja',
  // 韩国语: 
  'ko': 'ko',
  'ko-KR': 'ko',
  // 立陶宛语: 
  'lt': 'lt',
  'lt-LT': 'lt',
  // 拉脱维亚语: 
  'lv': 'lv',
  'lv-LV': 'lv',
  // 荷兰语: 
  'nl': 'nl',
  'nl-BE': 'nl',
  'nl-NL': 'nl',
  // 挪威语: 
  'no': 'no',
  'nb': 'no',
  'nn-NO': 'no',
  'nb-NO': 'no',
  // 波兰语: 
  'pl': 'pl',
  'pl-PL': 'pl',
  // 巴葡语: 
  'pt-BR': 'pt_BR',
  // 欧葡语: 
  'pt': 'pt',
  'pt-PT': 'pt',
  // 罗马尼亚语: 
  'ro': 'ro',
  'ro-RO': 'ro',
  // 俄语: 
  'ru': 'ru',
  'ru-RU': 'ru',
  // 斯洛伐克语: 
  'sk': 'sk',
  'sk-SK': 'sk',
  // 斯洛文尼亚语: 
  'sl': 'sl',
  'sl-SI': 'sl',
  // 塞尔维亚语: 
  'sr': 'sr',
  'sr-BA': 'sr',
  'sr-SP': 'sr',
  // 瑞典语: 
  'sv': 'sv',
  'sv-FI': 'sv',
  'sv-SE': 'sv',
  // 泰国语: 
  'th': 'th',
  'th-TH': 'th',
  // 土耳其语: 
  'tr': 'tr',
  'tr-TR': 'tr',
  // 乌克兰语: 
  'uk': 'uk',
  'uk-UA': 'uk',
  // 乌兹别克语: 
  'uz': 'uz',
  'uz-UZ': 'uz',
  // 越南语: 
  'vi': 'vi',
  'vi-VN': 'vi',
  // 中文(简体): 
  'zh': 'zh_CN',
  'zh-CN': 'zh_CN',
  'zh_CN': 'zh_CN',
  // 中文(香港): 
  'zh-HK': 'zh_HK',
  'zh_HK': 'zh_HK',
  // 中文(繁体): 
  'zh-TW': 'zh_TW',
  'zh_TW': 'zh_TW',
  'zh-SG': 'zh_TW',
  'zh_SG': 'zh_TW'
}
